var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" © "+_vm._s(_vm.currentYear)+", Somoy Media Limited ")])}
var staticRenderFns = []

export { render, staticRenderFns }